import {
  Container,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import React, { useState } from "react";
import { Line } from "react-chartjs-2";
import { useGetRapidCryptoHistoryQuery } from "../services/RapidCryptoApi";
import { useParams } from "react-router-dom";
import LoadingPage from "../components/LoadingScreen";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Title as Title2,
} from "chart.js";

import { useDispatch } from "react-redux";
import { loadingActions } from "../store/loading-slice";

const Chart = () => {
  const dispatch = useDispatch();
  const { coinId } = useParams();
  const [timeperiod, setTimeperiod] = useState("3h");
  const {
    data: coinHistory,
    isFetching,
    isSuccess,
  } = useGetRapidCryptoHistoryQuery({
    coinId,
    timeperiod,
  });
  const time = ["3h", "24h", "7d", "30d", "1y", "3m", "3y", "5y"];

  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Tooltip,
    Legend,
    Title2
  );

  if (isFetching) {
    dispatch(loadingActions.openHandler());
    return <LoadingPage />;
  }

  if (isSuccess) {
    dispatch(loadingActions.closeHandler());
  }

  const coinPrice = [];
  const coinTimestamp = [];

  for (let i = 0; i < coinHistory?.data?.history?.length; i += 1) {
    coinPrice.push(coinHistory?.data?.history[i].price);
    coinTimestamp.push(coinHistory?.data?.history[i].timestamp);
  }

  console.log(coinHistory);

  const data = {
    labels: coinTimestamp.map((time) =>
      new Date(time).toLocaleDateString("en", {
        year: "numeric",
        month: "short",
        day: "numeric",
      })
    ),
    datasets: [
      {
        label: "Price In USD",
        data: coinPrice,
        fill: false,
        backgroundColor: "#0071bd",
        borderColor: "#0071bd",
      },
    ],
  };

  const options = {
    // scales: {
    //   yAxes: [
    //     {
    //       ticks: {
    //         beginAtZero: true,
    //       },
    //     },
    //   ],
    // },
  };

  return (
    <Container>
      <FormControl sx={{ m: 1, minWidth: 120 }}>
        <InputLabel id="demo-simple-select-helper-label">Time</InputLabel>
        <Select
          labelId="demo-simple-select-helper-label"
          id="demo-simple-select-helper"
          value={timeperiod}
          label="Time"
          onChange={(e) => setTimeperiod(e.target.value)}
        >
          {time.map((date) => (
            <MenuItem key={date} value={date}>
              {date}
            </MenuItem>
          ))}
        </Select>
        <FormHelperText>Select a time</FormHelperText>
      </FormControl>
      <Line data={data} options={options} />
    </Container>
  );
};

export default Chart;
